import apiClient from './api';
import type {
  AudienceFiltersResponse,
  AudienceFiltersWireResponse,
} from '@/types/audienceFilters.types';
import type {
  CategoryFiltersResponse,
  CategoryFiltersWireResponse,
} from '@/types/categoryFilters.types';
import { normalizeCategoryFiltersResponse } from '@/utils/categoryFilterCatalog';

export const catalogService = {
  getCategoryFilters: async (tenantCode: string): Promise<CategoryFiltersResponse> => {
    const response = await apiClient.get<CategoryFiltersWireResponse>(
      `/catalog/${encodeURIComponent(tenantCode)}/category-filters`
    );
    return normalizeCategoryFiltersResponse(response.data);
  },

  /**
   * Audiencias filtrables del tenant, ya ordenadas por sort_order (la primera es la primaria).
   * Lista vacía = tenant sin audiencias, o ninguna alcanzó la cobertura mínima todavía.
   */
  getAudienceFilters: async (tenantCode: string): Promise<AudienceFiltersResponse> => {
    const response = await apiClient.get<AudienceFiltersWireResponse>(
      `/catalog/${encodeURIComponent(tenantCode)}/audience-filters`
    );
    return {
      audiences: (response.data?.audiences ?? []).map(a => ({
        ...a,
        id: String(a.id),
      })),
    };
  },
};
